import React, { useState } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const CopyableText = ({ text }: { text: string }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500); // reset after 1.5s
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        alignSelf: "center",
        width: "100%",
        height: "100%",
        "&:hover .copy-button": { opacity: 1 },
      }}
    >
      <Typography
        variant="body1"
        noWrap
        sx={{
          flexGrow: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: "0.875rem",
        }}
      >
        {text}
      </Typography>

      <Tooltip title={copied ? "Copied!" : "Copy"}>
        <IconButton
          className="copy-button"
          onClick={handleCopy}
          sx={{
            opacity: 0,
            transition: "opacity 0.2s ease-in-out",
            flexShrink: 0,
          }}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default CopyableText;
